<template>
  <div
    class="relative w-full h-full"
    :id="getCanvasBoxId(cameraInfo.cameraIp, cameraInfo.cameraPort)"
  ></div>
</template>

<script>
import Axios from 'axios'

export default {
  props: {
    cameraInfo: {
      type: Object,
      default: () => {
        return {
          cameraIp: '',
          cameraPort: '',
        }
      },
      require: true,
    },
    isDialog: {
      type: Boolean,
      default: false,
      require: true,
    },
  },
  watch: {
    cameraInfo: {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal)
        this.$nextTick(() => {
          this.changeCode(newVal, oldVal)
        })
      },
      deep: true,
    },
  },
  data() {
    return {
      JSMpeg: null,
    }
  },
  methods: {
    async startCamera(cameraIp, cameraPort) {
      console.log('cameraIp', cameraIp, cameraPort)
      // 获取或创建 canvas 元素
      const canvas = document.createElement('canvas')
      canvas.id = this.getCanvasId(cameraIp, cameraPort)
      canvas.style.height = '100%'
      canvas.style.width = '100%'
      // canvas.addEventListener('click', toggleFullScreen)
      document.getElementById(this.getCanvasBoxId(this.cameraInfo.cameraIp, this.cameraInfo.cameraPort)).appendChild(canvas)

      const nowrtsp = `rtsp://admin:tc123456@${cameraIp}:${cameraPort}/cam/realmonitor?channel=1&subtype=0`

      // 内网测试用
      // const nowIp = '172.16.203.109'
      // const nowrtsp = 'rtsp://admin:pr@wiz.top@172.16.203.109/Streaming/Channels/1'

      try {
        // 请求 FFmpeg 流
        const response = await Axios.post(`http://${this.wsIP}:9999/postFFmpegStream`, {
          streamUrl: nowrtsp,
          wsPort: -1,
          ip: `${cameraIp}:${cameraPort}`,
        })

        const wsUrl = `ws://${this.wsIP}:${response.data.wsPort}`

        // 创建 JSMpeg 播放器
        this.$nextTick(() => {
          /* global JSMpeg */
          this.JSMpeg = new JSMpeg.Player(wsUrl, { canvas })
        })
      } catch (error) {
        console.error('请求 FFmpeg 流失败:', error)
      }
    },
    closeCamera(cameraIp, cameraPort) {
      this.JSMpeg = null
      const canvas = document.getElementById(this.getCanvasId(cameraIp, cameraPort))
      if (canvas) {
        // 销毁id等于playersinglecanvas的canvas
        canvas.remove()
      }
    },
    changeCode(newVal, oldVal) {
      this.closeCamera(oldVal.cameraIp, oldVal.cameraPort)
      this.startCamera(newVal.cameraIp, newVal.cameraPort)
    },
  },
  computed: {
    wsIP() {
      return Wiz.globalSettings.globalConfig?.robotCameraIp ?? '192.168.80.135'
    },
    getCanvasId() {
      return (cameraIp, cameraPort) => {
        if (this.isDialog) {
          return `playersinglecanvas${cameraIp}${cameraPort}dialog`
        }
        return `playersinglecanvas${cameraIp}${cameraPort}`
      }
    },
    getCanvasBoxId() {
      return (cameraIp, cameraPort) => {
        if (this.isDialog) {
          return `canvasbox${cameraIp}${cameraPort}dialog`
        }
        return `canvasbox${cameraIp}${cameraPort}`
      }
    },
  },
  mounted() {
    this.startCamera(this.cameraInfo.cameraIp, this.cameraInfo.cameraPort)
  },
  beforeDestroy() {
    this.closeCamera(this.cameraInfo.cameraIp, this.cameraInfo.cameraPort)
  },
}
</script>

<style lang="scss">
.playersinglecanvas {
  position: absolute; /* 绝对定位 */
  top: 0;
  left: 0;
  width: 100%; /* 自适应宽度 */
  height: 100%; /* 自适应高度 */
}

.fullscreen {
  position: fixed;
  top: -50%;
  left: 0;
  width: 100vh;
  height: 100vw;
  z-index: 9999;
  background: black;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(90deg);
  transform-origin: bottom left;
}

.fullscreen canvas {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transform: rotate(90deg);
  transition: transform 0.3s ease;
}
</style>
